import { useTranslation } from 'react-i18next';

import { FormTextField } from '~/components/atoms/form-fields/FormTextField';
import ContentQRBuilderHeader from '~/components/builder/ContentQRBuilderHeader';
import NameAndOrganizationBlock from '~/components/builder/NameAndOrganizationBlock';
import QrTypeTopCard from '~/components/builder/QrTypeTopCard';
import Accordion from '~/components/ui/Accordion/Accordion';
import { QRCODE_STATIC_TYPE } from '~/constants/qr-code';
import CreateQRContentBlockLayout from '~/pages/CreateQR/components/CreateQRContentBlockLayout/CreateQRContentBlockLayout';
import { StyledContentContainer, StyledFormContainer } from '~/pages/qrBuilder/p-static/commonStyled';
// import PasswordProtectionBlock from '~/components/builder/PasswordProtectionBlock';

export const StaticSmsForm = () => {
  const { t } = useTranslation();

  return (
    <StyledFormContainer>
      <ContentQRBuilderHeader />
      <QrTypeTopCard type={QRCODE_STATIC_TYPE.SMS} />
      <CreateQRContentBlockLayout defaultExpanded type="basicInfo">
        <Accordion
          defaultExpanded
          variant="child"
          hideBottomBorder
          summary={t('staticQrTemplates:sms:content:title')}
          details={
            <StyledContentContainer>
              <FormTextField
                name="number"
                fullWidth
                label={t('staticQrTemplates:sms:content:fields:number:label')}
                placeholder={t('staticQrTemplates:sms:content:fields:number:placeholder')}
                inputProps={{ maxLength: 40 }}
              />
              <FormTextField
                name="message"
                fullWidth
                label={t('staticQrTemplates:sms:content:fields:message:label')}
                placeholder={t('staticQrTemplates:sms:content:fields:message:placeholder')}
                inputProps={{ maxLength: 160 }}
                minRows={3}
                multiline
              />
            </StyledContentContainer>
          }
        />
      </CreateQRContentBlockLayout>
      <NameAndOrganizationBlock isStatic />
      {/*<PasswordProtectionBlock />*/}
    </StyledFormContainer>
  );
};
